import { ChevronDown, ChevronUp } from "lucide-react";

interface CollapseButtonProps {
  isCollapsed: boolean;
  onToggle: () => void;
  /** Accessible name for the icon-only button (collapse or expand). */
  ariaLabel: string;
}

export function CollapseButton({
  isCollapsed,
  onToggle,
  ariaLabel,
}: CollapseButtonProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onToggle}
      className="p-1.5 text-[#4b5563] hover:text-slate-300 hover:bg-[#0d0d14] rounded transition-colors"
    >
      {isCollapsed ? (
        <ChevronDown className="h-4 w-4" />
      ) : (
        <ChevronUp className="h-4 w-4" />
      )}
    </button>
  );
}
